import { FC, RefObject } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useFullScreen } from '../../../hooks';

interface ScanCompareFullScreenProps {
  containerRef: RefObject<HTMLDivElement>;
}

export const ScanCompareFullScreen: FC<ScanCompareFullScreenProps> = ({
  containerRef,
}) => {
  const { isFullScreen, toggleFullScreen } = useFullScreen(containerRef);

  return (
    <Tooltip
      title='full screen'
      placement='top'
      disableHoverListener={isFullScreen}
    >
      <IconButton
        sx={{
          padding: '12px',
          borderRadius: '8px',
          color: '#353535',
          backgroundColor: 'white',
          '&:hover': {
            backgroundColor: '#f5f5f5',
          },
        }}
        onClick={toggleFullScreen}
      >
        {isFullScreen ? (
          <FullscreenExitIcon fontSize='inherit' />
        ) : (
          <FullscreenIcon fontSize='inherit' />
        )}
      </IconButton>
    </Tooltip>
  );
};
